import script from "./CachePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CachePage.vue?vue&type=script&setup=true&lang=ts"

import "./CachePage.vue?vue&type=style&index=0&id=6a75d1b1&scoped=true&lang=css"
import "./CachePage.vue?vue&type=style&index=1&id=6a75d1b1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a75d1b1"]])

export default __exports__